import {ApiClient} from '@hconnect/apiclient'

import {MaterialStorage} from '../types'

export const CurrentMaterialStoragesQueryKey = 'material-storage-list'

export const currentMaterialStoragesQueryOptions = (plantId: string) => ({
  queryKey: [CurrentMaterialStoragesQueryKey, plantId] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<MaterialStorage[]>(
      `/plants/${plantId}/material-storage`,
      {signal}
    )
    return response.data
  }
})
